import App from "./App";
import './style/main.scss';
import domReady from '@wordpress/dom-ready';
import { createRoot } from 'react-dom/client';

let nexterRoot; // keep reference

domReady(() => {
    const nexterDash = document.getElementById('nexter-dash');
    if (nexterDash) {
        // if a root already exists, just update it
        if (!nexterRoot) {
            nexterRoot = createRoot(nexterDash);
        }
        nexterRoot.render(<App />);
    }
});
